var map = {
	"./arrow-right-filled.svg": 1188,
	"./arrow-triangle-down-filled.svg": 4477,
	"./arrow-triangle-down.svg": 192,
	"./arrow-triangle-up-filled.svg": 4220,
	"./arrow-triangle-up.svg": 355,
	"./bg-purple-1.svg": 1747,
	"./bg-purple-2.svg": 6608,
	"./border.svg": 9357,
	"./facebook.svg": 5283,
	"./hourglass.svg": 4495,
	"./instagram.svg": 4849,
	"./loading.svg": 7293,
	"./logo--purple--full.svg": 6951,
	"./logo--purple--icon.svg": 6963,
	"./logo--white--full.svg": 862,
	"./logo--white--icon.svg": 5394,
	"./logo-long.svg": 4473,
	"./logo.svg": 9438,
	"./paper-airplane.svg": 3086,
	"./twitter.svg": 9532
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5312;